import { render, staticRenderFns } from "./AppointmentConfirmation.vue?vue&type=template&id=37d6e50d&scoped=true"
import script from "./AppointmentConfirmation.vue?vue&type=script&lang=js"
export * from "./AppointmentConfirmation.vue?vue&type=script&lang=js"
import style0 from "./AppointmentConfirmation.vue?vue&type=style&index=0&id=37d6e50d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d6e50d",
  null
  
)

export default component.exports